// extracted by mini-css-extract-plugin
export default {"container":"UserGuides_container__9tKm0"};